// extracted by mini-css-extract-plugin
export default {"root":"BasicSubscriptionOption_root__oXmCo"};